import { Icons } from '@nxsys/types/icons';

type AppFileNameProps = {
  fileName: string;
};

const AppFileName: React.FC<AppFileNameProps> = ({ fileName }) => {
  const fileType = fileName.split('.').pop();

  const formatTypeToIcon = (type: string | undefined) => {
    switch (type) {
      case 'xls':
        return <Icons.IconExcelFile />;
      case 'xlsx':
        return <Icons.IconExcelFile />;
      default:
        return <Icons.IconFile />;
    }
  };

  return (
    <div className="flex items-center gap-x-2">
      <span>{formatTypeToIcon(fileType)}</span>
      <span className="flex-1 truncate">{fileName}</span>
    </div>
  );
};

export default AppFileName;
